<template>
  <div class="seo">
    <p class="title">{{name}}</p>
    <b-field label="Title">
      <b-input
        v-model.lazy="value.title"
        :disabled="disabled"
        @input="updateValue"
      />
    </b-field>
    <b-field label="Description">
      <b-input
        type="textarea"
        v-model.lazy="value.description"
        :disabled="disabled"
        @input="updateValue"
      />
    </b-field>
    <b-field label="OG Title">
      <b-input
        v-model.lazy="value.ogTitle"
        :disabled="disabled"
        @input="updateValue"
      />
    </b-field>
    <b-field label="OG Description">
      <b-input
        v-model.lazy="value.ogDescription"
        type="textarea"
        :disabled="disabled"
        @input="updateValue"
      />
    </b-field>
    <b-field :label="`OG Image (${width} x ${height})`"
      >
      <b-field class="file">
        <b-upload v-model="ogImage" accept="image/*" @input="updateValue">
          <a class="button is-primary">
            <b-icon icon="upload"></b-icon>
            <span>Click to upload</span>
          </a>
        </b-upload>
        <span class="file-name" v-if="ogImage">
          {{ ogImage.name }}
        </span>
      </b-field>
    </b-field>
    <b-field>
      <div class="image-preview">
        <div
          class="image"
          v-if="ogImage || value.ogMediaUrl"
        >
          <img
            ref="ogImage"
            :src="ogImage
              ? getImageFromBlob(ogImage, 'ogImage')
              : value.ogMediaUrl"
            :style="[width, height] | maxSize"
          >
        </div>
      </div>
    </b-field>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'seo',
  props: {
    name: {
      type: String,
      required: false,
      default: 'SEO',
    },
    value: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    width: {
      type: Number,
      required: false,
      default: 1200,
    },
    height: {
      type: Number,
      required: false,
      default: 630,
    },
  },
  filters: {
    maxSize(sizes) {
      return `max-width: ${sizes[0]}px; max-height: ${sizes[1]}px;`;
    },
  },
  data() {
    return {
      ogImage: null,
    };
  },
  methods: {
    ...mapActions('upload', {
      upload: 'image',
    }),
    updateValue() {
      this.$emit('input', Object.assign({}, this.value, { ogImage: this.ogImage }));
    },
    getImageFromBlob(file, ref) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.$refs[ref].src = e.target.result;
      };

      reader.readAsDataURL(file);
    },
    uploadOgImage() {
      return this.upload({
        file: this.ogImage,
        options: {
          resize: {
            width: this.width,
            height: this.height,
          },
        },
      });
    },
  },
};
</script>

<style lang="sass" scoped>
.image-preview
  .image
    img
      width: auto
      height: auto
      object-fit: contain
</style>
